import type { ChatComposerAttachment } from './types';

export function formatBytes(size: number) {
  if (size <= 0) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB'];
  const index = Math.min(
    units.length - 1,
    Math.floor(Math.log(size) / Math.log(1024))
  );
  const value = size / 1024 ** index;
  return `${value >= 10 || index === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[index]}`;
}

export function formatVoiceDuration(duration: number) {
  const totalSeconds = Math.max(0, Math.floor(duration));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export function getAttachmentMeta(attachment: ChatComposerAttachment) {
  if (attachment.status === 'uploading') {
    return 'Preparing attachment…';
  }
  if (attachment.status === 'ready') {
    return 'Ready to send';
  }
  if (attachment.status === 'failed') {
    return attachment.error || 'Attachment failed';
  }
  return formatBytes(attachment.size);
}
